__turbopack_context__.v({
  "agent-info": "style-module-scss-module__FVYfDW__agent-info",
  "agent-location": "style-module-scss-module__FVYfDW__agent-location",
  "agent-name": "style-module-scss-module__FVYfDW__agent-name",
  "avatar-large": "style-module-scss-module__FVYfDW__avatar-large",
  "bottom-section": "style-module-scss-module__FVYfDW__bottom-section",
  "component": "style-module-scss-module__FVYfDW__component",
  "component-mobile": "style-module-scss-module__FVYfDW__component-mobile",
  "content-container": "style-module-scss-module__FVYfDW__content-container",
  "copyable-text": "style-module-scss-module__FVYfDW__copyable-text",
  "cta-button": "style-module-scss-module__FVYfDW__cta-button",
  "military-badge": "style-module-scss-module__FVYfDW__military-badge",
  "section-1": "style-module-scss-module__FVYfDW__section-1",
  "section-2": "style-module-scss-module__FVYfDW__section-2",
  "section-3": "style-module-scss-module__FVYfDW__section-3",
  "title-badge-container": "style-module-scss-module__FVYfDW__title-badge-container",
  "top-left-section": "style-module-scss-module__FVYfDW__top-left-section",
  "top-right-section": "style-module-scss-module__FVYfDW__top-right-section",
  "top-section": "style-module-scss-module__FVYfDW__top-section",
});
